
const useSchoolFields = () => {

    const personalFields = [
        {
            name: "name",
            component: "input",
            placeholder: "שם"
        },
        {
            name: "role",
            component: "autoComplete",
            placeholder: "תפקיד",
            options: [{ id: "teacher", name: "מורה" }, { id: "principal", name: "מנהלת" }, { id: "coordinator", name: "מרכזת" }]
        }
    ]

    const schoolFields = [
        {
            name: "school_name",
            component: "input",
            placeholder: "שם בית הספר"
        },
        {
            name: "school_email",
            component: "input",
            placeholder: "אימייל"
        },
        {
            name: "school_phone",
            component: "input",
            placeholder: "טלפון ליצירת קשר"
        }
    ]

    return {
        personalFields,
        schoolFields
    }
}

export default useSchoolFields